var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_457)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61497 4.64453L5.64173 5.23732C5.74196 5.29519 5.77438 5.42668 5.71795 5.52443C5.65981 5.62512 5.53435 5.66152 5.4312 5.60197L4.38705 4.99913C4.28014 5.08215 4.14584 5.13158 4 5.13158C3.65119 5.13158 3.36842 4.84881 3.36842 4.5C3.36842 4.22501 3.54417 3.99106 3.78947 3.90436V1.97512C3.78947 1.85806 3.88713 1.76316 4 1.76316C4.11627 1.76316 4.21053 1.86122 4.21053 1.97512V3.90436C4.45583 3.99106 4.63158 4.22501 4.63158 4.5C4.63158 4.54973 4.62583 4.59811 4.61497 4.64453ZM4 8.5C6.20914 8.5 8 6.70914 8 4.5C8 2.29086 6.20914 0.5 4 0.5C1.79086 0.5 0 2.29086 0 4.5C0 6.70914 1.79086 8.5 4 8.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.9d364af5df808eef4253073d9cfbdfab.svg";
export { ForwardRef as ReactComponent };